import { FineMqPlugin } from 'fine-mq'
import Vue from 'vue'

Vue.use(FineMqPlugin, {
  aliases: {
    xs: [490, 543],
    sm: [544, 767],
    md: [768, 1023],
    lg: [1024, 1199],
    xl: [1200], // <=> [1200, Infinity]
    landscape: '(orientation: landscape)',
  },
})
